import { create } from 'zustand';

interface Toast {
  id: string;
  message: string;
  type: 'info' | 'error' | 'success';
}

let toastId = 0;

interface ToastState {
  toasts: Toast[];
  addToast: (message: string, type?: Toast['type']) => void;
  removeToast: (id: string) => void;
}

export const useToastStore = create<ToastState>(set => ({
  toasts: [],
  addToast: (message, type = 'info') => {
    const id = `toast_${++toastId}`;
    set(state => ({ toasts: [...state.toasts.slice(-2), { id, message, type }] }));
    setTimeout(() => {
      set(state => ({ toasts: state.toasts.filter(t => t.id !== id) }));
    }, 3000);
  },
  removeToast: id => set(state => ({ toasts: state.toasts.filter(t => t.id !== id) })),
}));
